var _circle, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOrderSubmit(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 42.5,
    cy: 40.5,
    r: 25.5,
    fill: "#E1E9FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.042 24.0688L24.1982 29.225L32.792 20.6313",
    stroke: "#70707A",
    strokeWidth: 4.41667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.6667 8.875H12.1667C10.901 8.875 9.875 9.90101 9.875 11.1667V38.6667C9.875 39.9323 10.901 40.9583 12.1667 40.9583H39.6667C40.9323 40.9583 41.9583 39.9323 41.9583 38.6667V11.1667C41.9583 9.90101 40.9323 8.875 39.6667 8.875Z",
    stroke: "#70707A",
    strokeWidth: 4.41667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.042 50.125H48.8337C49.4414 50.125 50.0243 49.8835 50.4541 49.4538C50.8839 49.024 51.1253 48.4411 51.1253 47.8333V13.4583",
    stroke: "#70707A",
    strokeWidth: 4.41667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrderSubmit);
export default __webpack_public_path__ + "static/media/orderSubmit.a89a93b44b2f24a520dc22278ad4128d.svg";
export { ForwardRef as ReactComponent };